// extracted by mini-css-extract-plugin
module.exports = {"address":"styles_address__79rd6","address__wrapper":"styles_address__wrapper__AzHBk","skeleton-animation":"styles_skeleton-animation__OGj6W"};